import { CanActivateFn, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@abp/ng.core';

/**
 * ABP'nin varsayılan authGuard'ı Code Flow ile identity server'a yönlendiriyor.
 * Bu guard ise Angular'ın kendi /account/login sayfasına yönlendirir.
 */
export const customAuthGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated) {
    return true;
  }

  return router.createUrlTree(['/account/login'], {
    queryParams: { returnUrl: state.url },
  });
};
